export const loadJS = (src, attrs = {}) => new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.async = true;
    Object.keys(attrs).forEach((key) => script.setAttribute(key, attrs[key]));
    script.src = src;
    script.onload = () => resolve();
    script.onerror = reject;
    document.head.appendChild(script);
});
//# sourceMappingURL=resource.js.map